/* ================================================================
   VAULT SOUNDS THEME v2 — vault.js
================================================================ */
(function () {
  'use strict';

  /* ─── CART API ─── */
  const Cart = {
    async get() { return fetch('/cart.js').then(r => r.json()); },
    async add(id, qty) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id, quantity: qty || 1 })
      });
      if (!r.ok) { const e = await r.json(); throw new Error(e.description || 'Error'); }
      return r.json();
    },
    async change(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line, quantity: qty })
      }).then(r => r.json());
    }
  };

  const $ = id => document.getElementById(id);
  const money = c => '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const esc = s => { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; };

  /* ─── CART BADGE ─── */
  function updateBadge(count) {
    const b = $('CartBadge');
    if (!b) return;
    b.textContent = count;
    b.classList.toggle('cart-badge--hidden', count === 0);
    $('CartToggle')?.setAttribute('aria-label', `Cart — ${count} item${count !== 1 ? 's' : ''}`);
  }

  /* ─── CART DRAWER ─── */
  const CartDrawer = {
    init() { this.el = $('CartDrawer'); this.body = $('CartBody'); this.footer = $('CartFooter'); },
    open()  { if (!this.el) return; this.el.classList.add('open'); this.el.setAttribute('aria-hidden','false'); $('CartOverlay')?.classList.add('open'); document.body.style.overflow = 'hidden'; },
    close() { if (!this.el) return; this.el.classList.remove('open'); this.el.setAttribute('aria-hidden','true'); $('CartOverlay')?.classList.remove('open'); document.body.style.overflow = ''; },

    async refresh() {
      const cart = await Cart.get();
      updateBadge(cart.item_count);
      if (!this.body) return;
      if (!cart.item_count) {
        this.body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/" class="btn btn--dark">Browse Packs</a></div>';
        if (this.footer) this.footer.style.display = 'none';
        return;
      }
      this.body.innerHTML = `<ul class="cart-items" role="list">${cart.items.map((item, i) => `
        <li class="cart-item" data-line="${i+1}">
          <a href="${item.url}" class="cart-item__img">${item.image ? `<img src="${item.image}" alt="${esc(item.title)}" width="72" height="72" loading="lazy">` : ''}</a>
          <div class="cart-item__info">
            <a href="${item.url}" class="cart-item__name">${esc(item.product_title)}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${esc(item.variant_title)}</div>` : ''}
            <div class="cart-item__price">${money(item.final_price)}</div>
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-action="cart-qty" data-line="${i+1}" data-delta="-1" aria-label="Decrease">−</button>
              <span class="cart-item__qty-num">${item.quantity}</span>
              <button class="cart-item__qty-btn" data-action="cart-qty" data-line="${i+1}" data-delta="1" aria-label="Increase">+</button>
            </div>
            <button class="cart-item__remove" data-action="remove-item" data-line="${i+1}" aria-label="Remove ${esc(item.product_title)}">Remove</button>
          </div>
        </li>`).join('')}</ul>`;
      if (this.footer) {
        this.footer.style.display = '';
        const sub = $('CartSubtotal');
        if (sub) sub.textContent = money(cart.total_price);
      }
    }
  };

  /* ─── MENU DRAWER ─── */
  const MenuDrawer = {
    init() { this.el = $('MenuDrawer'); this.btn = $('Hamburger'); },
    open()   {
      if (!this.el) return;
      $('Sidebar')?.classList.remove('mobile-open');
      $('SidebarOverlay')?.classList.remove('open');
      $('MobileFilterBtn')?.setAttribute('aria-expanded','false');
      this.el.classList.add('open'); this.el.setAttribute('aria-hidden','false');
      this.btn?.classList.add('open'); this.btn?.setAttribute('aria-expanded','true');
      $('MenuOverlay')?.classList.add('open');
    },
    close()  { if (!this.el) return; this.el.classList.remove('open'); this.el.setAttribute('aria-hidden','true'); this.btn?.classList.remove('open'); this.btn?.setAttribute('aria-expanded','false'); $('MenuOverlay')?.classList.remove('open'); },
    toggle() { this.el?.classList.contains('open') ? this.close() : this.open(); }
  };

  /* ─── SEARCH ─── */
  const Search = {
    init() { this.box = $('SearchBox'); this.toggle = $('SearchToggle'); this.input = $('SearchInput'); },
    open()   {
      if (!this.box) return;
      this.box.classList.add('open');
      this.box.setAttribute('aria-hidden','false');
      this.toggle?.setAttribute('aria-expanded','true');
      if (this.toggle) this.toggle.style.opacity = '0';
      setTimeout(() => this.input?.focus(), 20);
    },
    close()  {
      if (!this.box) return;
      this.box.classList.remove('open');
      this.box.setAttribute('aria-hidden','true');
      this.toggle?.setAttribute('aria-expanded','false');
      if (this.toggle) this.toggle.style.opacity = '';
      if (this.input) { this.input.value = ''; catalogSearch(''); }
    }
  };

  /* ─── CLIENT-SIDE SEARCH on catalog page ─── */
  // Levenshtein distance, capped at `max` (returns max+1 if exceeded — saves work)
  function lev(a, b, max) {
    if (a === b) return 0;
    const al = a.length, bl = b.length;
    if (Math.abs(al - bl) > max) return max + 1;
    if (!al) return bl; if (!bl) return al;
    let prev = new Array(bl + 1);
    let curr = new Array(bl + 1);
    for (let j = 0; j <= bl; j++) prev[j] = j;
    for (let i = 1; i <= al; i++) {
      curr[0] = i;
      let rowMin = i;
      for (let j = 1; j <= bl; j++) {
        const cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
        if (curr[j] < rowMin) rowMin = curr[j];
      }
      if (rowMin > max) return max + 1;
      [prev, curr] = [curr, prev];
    }
    return prev[bl];
  }

  // How forgiving to be based on token length
  function tolerance(len) {
    if (len <= 2) return 0;
    if (len <= 4) return 1;
    return 2;
  }

  // True if any haystack token matches the query token within tolerance
  function tokenMatches(qTok, hayTokens) {
    const tol = tolerance(qTok.length);
    for (const h of hayTokens) {
      if (h.includes(qTok) || qTok.includes(h)) return true;
      if (tol > 0 && lev(qTok, h, tol) <= tol) return true;
    }
    return false;
  }

  function catalogSearch(query) {
    const grid = $('ProductGrid');
    if (!grid) return;
    const q = query.trim().toLowerCase();
    const qTokens = q.split(/\s+/).filter(Boolean);
    const cards = grid.querySelectorAll('.p-card');
    let visible = 0;
    cards.forEach(card => {
      const text = ((card.querySelector('.p-card__title')?.textContent || '') + ' ' +
                    (card.querySelector('.p-card__vendor')?.textContent || '')).toLowerCase();
      let show = !q;
      if (q) {
        if (text.includes(q)) {
          show = true;
        } else {
          const hayTokens = text.split(/[\s,/\-_().]+/).filter(Boolean);
          show = qTokens.every(t => tokenMatches(t, hayTokens));
        }
      }
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    const noResults = $('NoResultsMsg');
    if (noResults) noResults.style.display = visible === 0 && cards.length > 0 ? 'flex' : 'none';
    const countEl = $('TopbarCount');
    if (countEl) countEl.textContent = q ? visible : cards.length;
    const pagination = $('Pagination');
    if (pagination) pagination.style.display = q ? 'none' : '';
  }

  /* ─── ADD TO CART ─── */
  async function handleATC(btn) {
    const vid = btn.dataset.variantId;
    if (!vid) return;
    const orig = btn.innerHTML;
    const isCorner = btn.classList.contains('p-card__atc-corner');
    if (isCorner) {
      btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="1,6 4,9 11,2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    } else {
      btn.textContent = 'Adding…';
    }
    btn.disabled = true;
    try {
      const qty = parseInt($('QtyInput')?.value || '1') || 1;
      await Cart.add(Number(vid), isCorner ? 1 : qty);
      await CartDrawer.refresh();
      if (isCorner) {
        btn.classList.add('added');
        CartDrawer.open();
        setTimeout(() => { btn.innerHTML = orig; btn.classList.remove('added'); btn.disabled = false; }, 1400);
      } else {
        btn.textContent = '✓ Added';
        btn.style.background = '#207758';
        CartDrawer.open();
        setTimeout(() => { btn.textContent = orig; btn.style.background = ''; btn.disabled = false; }, 1500);
      }
    } catch {
      btn.innerHTML = orig;
      btn.disabled = false;
    }
  }

  /* ─── CLIENT-SIDE GRID SORT (All Releases) ─── */
  function sortGridClient(sortBy) {
    const grid = $('ProductGrid');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.p-card'));
    const cmp = {
      'created-descending': (a, b) => parseInt(b.dataset.created) - parseInt(a.dataset.created),
      'created-ascending':  (a, b) => parseInt(a.dataset.created) - parseInt(b.dataset.created),
      'price-ascending':    (a, b) => parseInt(a.dataset.price)   - parseInt(b.dataset.price),
      'price-descending':   (a, b) => parseInt(b.dataset.price)   - parseInt(a.dataset.price),
      'title-ascending':    (a, b) => textOf(a).localeCompare(textOf(b)),
      'title-descending':   (a, b) => textOf(b).localeCompare(textOf(a)),
    }[sortBy];
    if (!cmp) return;
    cards.sort(cmp).forEach((c, i) => {
      grid.appendChild(c);
      restampAnimation(c, i);
    });
  }
  function textOf(card) {
    return (card.querySelector('.p-card__title')?.textContent || '').trim().toLowerCase();
  }
  function restampAnimation(card, index) {
    card.style.animation = 'none';
    void card.offsetWidth;
    card.style.animationDelay = (index * 0.029) + 's';
    card.style.animation = '';
  }

  /* ─── COLLECTION FILTERS ─── */
  function initCollectionFilters() {
    const page = document.querySelector('.catalog-page');
    if (!page) return;

    // Default sort to "Date, new to old" for All Releases — read URL directly
    const isAll  = page.dataset.isAllReleases === 'true';
    const urlObj = new URL(window.location.href);
    const urlSort = urlObj.searchParams.get('sort_by') || '';
    if (isAll) {
      const effectiveSort = urlSort || 'created-descending';
      const sel = $('SortBy');
      if (sel) sel.value = effectiveSort;
      sortGridClient(effectiveSort);
    } else {
      // Other collection pages: trigger the cascade animation in display order
      const grid = $('ProductGrid');
      if (grid) Array.from(grid.querySelectorAll('.p-card')).forEach(restampAnimation);
    }

    // Sort dropdown
    $('SortBy')?.addEventListener('change', function () {
      if (isAll) {
        sortGridClient(this.value);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      }
    });

    // Filter checkboxes (Shopify storefront filters)
    document.querySelectorAll('[data-action="filter-change"]').forEach(cb => {
      cb.addEventListener('change', submitFilters);
    });

    // Price apply
    document.querySelectorAll('[data-action="apply-price-filter"]').forEach(btn => {
      btn.addEventListener('click', submitFilters);
    });

    // Price dual-knob slider
    initPriceSlider();

    // Sidebar section toggles
    document.querySelectorAll('[data-action="toggle-filter-section"]').forEach(btn => {
      btn.addEventListener('click', function () {
        const open = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!open));
        const id   = this.getAttribute('aria-controls');
        const body = id ? document.getElementById(id) : null;
        if (body) body.style.display = open ? 'none' : '';
        this.closest('.sb-section')?.classList.toggle('collapsed', open);
      });
    });

    // Hide/show sidebar desktop
    const hideBtn = $('HideFiltersBtn');
    const sidebar = $('Sidebar');
    if (hideBtn && sidebar) {
      let hidden = false;
      hideBtn.addEventListener('click', () => {
        hidden = !hidden;
        sidebar.classList.toggle('hidden', hidden);
        hideBtn.textContent = hidden ? 'Show Filters' : 'Hide Filters';
        hideBtn.setAttribute('aria-pressed', hidden);
      });
    }

    // Mobile filter drawer
    const mobileBtn     = $('MobileFilterBtn');
    const sidebarOvl    = $('SidebarOverlay');
    if (mobileBtn && sidebar) {
      mobileBtn.addEventListener('click', () => {
        $('MenuDrawer')?.classList.remove('open');
        $('MenuOverlay')?.classList.remove('open');
        $('Hamburger')?.classList.remove('open');
        $('Hamburger')?.setAttribute('aria-expanded','false');
        sidebar.classList.add('mobile-open');
        sidebarOvl?.classList.add('open');
        mobileBtn.setAttribute('aria-expanded','true');
      });
    }
    const closeSidebar = () => {
      sidebar?.classList.remove('mobile-open');
      sidebarOvl?.classList.remove('open');
      $('MobileFilterBtn')?.setAttribute('aria-expanded','false');
    };
    sidebarOvl?.addEventListener('click', closeSidebar);
    $('SidebarClose')?.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sidebar?.classList.contains('mobile-open')) closeSidebar();
    });

    // Client-side search — wired to header search input on catalog page
    const searchInput = $('SearchInput');
    if (searchInput) {
      let st;
      searchInput.addEventListener('input', function () {
        clearTimeout(st);
        st = setTimeout(() => catalogSearch(this.value), 180);
      });
    }
  }

  function initPriceSlider() {
    const wrap = document.querySelector('.price-buckets');
    if (!wrap) return;
    const grid = $('ProductGrid');
    if (!grid) return;
    const cards = grid.querySelectorAll('.p-card');
    const buttons = wrap.querySelectorAll('.price-bucket');

    function applyBucket(activeBtn) {
      const lo = activeBtn ? parseInt(activeBtn.dataset.min, 10) * 100 : null;
      const hi = activeBtn ? parseInt(activeBtn.dataset.max, 10) * 100 : null;
      let visible = 0;
      cards.forEach(card => {
        const price = parseInt(card.dataset.price, 10);
        const show = !activeBtn || (price >= lo && price <= hi);
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      buttons.forEach(b => b.classList.toggle('price-bucket--active', b === activeBtn));
      const noResults = $('NoResultsMsg');
      if (noResults) noResults.style.display = visible === 0 && cards.length > 0 ? 'flex' : 'none';
      const countEl = $('TopbarCount');
      if (countEl) countEl.textContent = activeBtn ? visible : cards.length;
      const pagination = $('Pagination');
      if (pagination) pagination.style.display = activeBtn ? 'none' : '';
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const wasActive = btn.classList.contains('price-bucket--active');
        applyBucket(wasActive ? null : btn);
      });
    });
  }

  function submitFilters() {
    const url = new URL(window.location.href);
    // Filter URL params only work on actual collection pages — redirect from / to /collections/all
    if (url.pathname === '/' || url.pathname === '') {
      url.pathname = '/collections/all';
    }
    [...url.searchParams.keys()].filter(k => k.startsWith('filter.')).forEach(k => url.searchParams.delete(k));
    url.searchParams.delete('page');
    document.querySelectorAll('[data-action="filter-change"]:checked').forEach(cb => url.searchParams.append(cb.name, cb.value));
    const minP = $('PriceMin'), maxP = $('PriceMax');
    if (minP?.name && minP.value) url.searchParams.set(minP.name, parseFloat(minP.value) * 100);
    if (maxP?.name && maxP.value) url.searchParams.set(maxP.name, parseFloat(maxP.value) * 100);
    // Preserve newest-first sort on All Releases when filtering
    const page = document.querySelector('.catalog-page');
    if (page?.dataset.isAllReleases === 'true' && !url.searchParams.has('sort_by')) {
      url.searchParams.set('sort_by', 'created-descending');
    }
    window.location.href = url.toString();
  }

  /* ─── PRODUCT PAGE ─── */
  function initProductPage() {
    if (!document.querySelector('.product-page')) return;

    // Qty
    const qtyInput = $('QtyInput');
    $('QtyMinus')?.addEventListener('click', () => { if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value||1)-1); });
    $('QtyPlus')?.addEventListener('click',  () => { if (qtyInput) qtyInput.value = parseInt(qtyInput.value||1)+1; });

    // Variant selector
    const productData = (function() {
      try { return JSON.parse($('ProductJSON')?.textContent || 'null'); } catch { return null; }
    })();

    document.querySelectorAll('[data-action="select-option"]').forEach(btn => {
      btn.addEventListener('click', function () {
        const idx   = parseInt(this.dataset.optionIndex);
        const value = this.dataset.optionValue;
        this.closest('.variant-option__btns')?.querySelectorAll('.variant-btn').forEach(b => {
          b.classList.toggle('active', b.dataset.optionValue === value);
          b.setAttribute('aria-pressed', b.dataset.optionValue === value ? 'true' : 'false');
        });
        if (productData) matchVariant(productData, idx, value);
      });
    });

    // Gallery thumbs
    document.querySelectorAll('[data-action="set-gallery-image"]').forEach(btn => {
      btn.addEventListener('click', function () {
        const img = $('GalleryMainImg');
        if (img) { img.src = this.dataset.src; if (this.dataset.srcset) img.srcset = this.dataset.srcset; }
        document.querySelectorAll('[data-action="set-gallery-image"]').forEach(b => b.classList.toggle('active', b === this));
      });
    });

    // Video
    const vp = $('VideoPlaceholder');
    if (vp) {
      const play = () => {
        let url = vp.dataset.url || '';
        if (url.includes('youtube.com/watch')) { const v = new URL(url).searchParams.get('v'); url = `https://www.youtube.com/embed/${v}?autoplay=1`; }
        else if (url.includes('youtu.be/'))    { const v = url.split('youtu.be/')[1].split('?')[0]; url = `https://www.youtube.com/embed/${v}?autoplay=1`; }
        const wrap = $('VideoWrap');
        if (wrap) wrap.innerHTML = `<iframe src="${url}" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      };
      vp.addEventListener('click', play);
      vp.addEventListener('keydown', e => { if (e.key==='Enter'||e.key===' ') play(); });
    }
  }

  function matchVariant(product, changedIdx, changedValue) {
    const selected = [];
    document.querySelectorAll('.variant-option__btns').forEach((group, i) => {
      selected[i] = i === changedIdx ? changedValue : (group.querySelector('.variant-btn.active')?.dataset.optionValue || '');
    });
    const variant = product.variants.find(v => v.options.every((o, i) => o === selected[i]));
    if (!variant) return;
    const atcBtn = $('AtcBtn');
    if (atcBtn) {
      atcBtn.dataset.variantId = variant.id;
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    const priceEl = $('ProductPrice');
    if (priceEl) {
      const sale = variant.compare_at_price > variant.price;
      const pct  = sale ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) : 0;
      priceEl.innerHTML = `<span class="price-current">${money(variant.price)}</span>${sale ? `<s class="price-was">${money(variant.compare_at_price)}</s><span class="price-save">${pct}% OFF</span>` : ''}`;
    }
    document.querySelectorAll('[data-variant-desc]').forEach(el => {
      el.hidden = String(el.dataset.variantDesc) !== String(variant.id);
    });
  }

  /* ─── GLOBAL CLICK DELEGATION ─── */
  document.addEventListener('click', async e => {
    const t = e.target.closest('[data-action]');
    if (!t) return;
    switch (t.dataset.action) {
      case 'add-to-cart':   e.preventDefault(); await handleATC(t); break;
      case 'remove-item': {
        const cart = await Cart.change(parseInt(t.dataset.line), 0);
        updateBadge(cart.item_count);
        await CartDrawer.refresh();
        break;
      }
      case 'cart-qty': {
        const line = parseInt(t.dataset.line, 10);
        const delta = parseInt(t.dataset.delta, 10);
        const numEl = t.parentElement.querySelector('.cart-item__qty-num');
        const current = parseInt(numEl?.textContent || '1', 10);
        const next = Math.max(0, current + delta);
        const cart = await Cart.change(line, next);
        updateBadge(cart.item_count);
        await CartDrawer.refresh();
        break;
      }
      case 'cart-page-qty': {
        e.preventDefault();
        const line = parseInt(t.dataset.line, 10);
        const delta = parseInt(t.dataset.delta, 10);
        const input = document.querySelector(`.cart-page__item-qty input[data-line="${line}"]`);
        const current = parseInt(input?.value || '1', 10);
        const next = Math.max(0, current + delta);
        await Cart.change(line, next);
        window.location.reload();
        break;
      }
      case 'cart-page-remove': {
        e.preventDefault();
        const line = parseInt(t.dataset.line, 10);
        await Cart.change(line, 0);
        window.location.reload();
        break;
      }
    }
  });

  /* ─── HEADER WIRING ─── */
  $('CartToggle')?.addEventListener('click',   () => CartDrawer.open());
  $('CartClose')?.addEventListener('click',    () => CartDrawer.close());
  $('CartOverlay')?.addEventListener('click',  () => CartDrawer.close());
  $('Hamburger')?.addEventListener('click',    () => MenuDrawer.toggle());
  $('MenuOverlay')?.addEventListener('click',  () => MenuDrawer.close());
  $('SearchToggle')?.addEventListener('click', () => Search.open());
  $('SearchClose')?.addEventListener('click',  () => Search.close());

  /* ─── ESC ─── */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    CartDrawer.close(); MenuDrawer.close(); Search.close();
    $('Sidebar')?.classList.remove('mobile-open');
    $('SidebarOverlay')?.classList.remove('open');
  });

  /* ─── DRAWER TOP TRACKER ─── */
  const updateDrawerTop = () => {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const bottom = Math.max(0, header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--drawer-top', bottom + 'px');
  };

  /* ─── INIT ─── */
  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    MenuDrawer.init();
    Search.init();
    initCollectionFilters();
    initProductPage();
    updateDrawerTop();
    window.addEventListener('scroll', updateDrawerTop, { passive: true });
    window.addEventListener('resize', updateDrawerTop);
  });

})();
